import React from 'react';
import { Form, Icon, Input, Button, notification } from 'antd';
import {
  login,
  setAuthorization,
} from '../../modules/Api';

import {userHasPermission} from '../../components/ACL';

const FormItem = Form.Item;

class Login extends React.Component {
  constructor() {
    super();
    var end = new Date();
    end.setHours(23,59,58);
    this.state = {
        submitted: false,
    }

}
  saveUserInfo = (res) => {
    const {data} = res;
    const hasAccess = userHasPermission(data.roles, data.permissions, 'dashboard_login');
    if (hasAccess) {
      sessionStorage.setItem('userInfo', JSON.stringify(data));
      window.location.replace('/');
    } else {
      notification.open({
        message: `شما دسترسی لازم برای ورود به سیستم را ندارید!`,
        description: `ممکن است دسترسی شما مسدود شده باشد، مدیریت اطلاع دهید.`
      })
    }
  }
  makeLogin = (res) => {
    const {data} = res.data;
    if(data.api == undefined) {
      return this.onError({});
    }
    const token = data.api.token;
    // save it
    sessionStorage.setItem('token', token);
    // api setup
    setAuthorization(token);
    // get user info
    // getUserInfo(this.saveUserInfo)
    this.saveUserInfo(res.data)

  }
  onError(res) {
    notification.open({
      message: 'نام کاربری یا رمز عبور اشتباه است',
      description: 'فیلد ها را با دقت پر کنید'
    });
  }
  sendSmsCode = (res) => {
    console.log(res);
    if(res.data.status == 'fail') {
      return this.onError({});
    }
    if(res.data.data.api != null){
      return this.makeLogin(res);
    }
    notification.open({
      message: 'کد تایید ارسال شد',
      description: 'کد تایید برای شما ارسال شد، لطفا آن را وارد کنید'
    });

    
  }
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        login(values, this.sendSmsCode, this.onError)
        this.setState({submitted: true});

      }
      
    });
  }
  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Form onSubmit={this.handleSubmit} className="login-form" style={{width: '33.33%', margin: '0px 33.33%'}}>
        <FormItem>
          {getFieldDecorator('username', {
            rules: [{ required: true, message: 'لطفا نام کاربری خود را وارد نمایید.' }],
          })(
            <Input prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="نام کاربری" />
          )}
        </FormItem>
        <FormItem>
          {getFieldDecorator('password', {
            rules: [{ required: true, message: 'لطفا رمز عبور خود را وارد نمایید.' }],
          })(
            <Input prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} type="password" placeholder="رمز عبور" />
          )}
        </FormItem>
        {this.state.submitted &&
        <FormItem>
          {getFieldDecorator('confirm', {
            rules: [{ required: true, message: 'کد تایید را وارد کنید' }],
          })(
            <Input prefix={<Icon  style={{ color: 'rgba(0,0,0,.25)' }} />} type="number" placeholder="کد تایید" />
          )}
        </FormItem>
        }
        <FormItem>

          <Button type="primary" htmlType="submit" className="login-form-button">
            ورود
          </Button>
        </FormItem>
      </Form>
    );
  }
}


export default Form.create()(Login);


// WEBPACK FOOTER //
// ./src/containers/Login/index.js